module.exports = __webpack_public_path__ + "static/media/cash-drawer.98308b86.svg";